import SolarEvolution from "@/components/site/SolarEvolution";
import NetMeteringDiagram from "@/components/site/NetMeteringDiagram";
import PPAComparison from "@/components/site/PPAComparison";
import PageMeta from "@/components/site/PageMeta";

export default function HowSolarWorksPage() {
  return (
    <main className="pt-24 md:pt-32" data-testid="how-solar-works-page">
      <PageMeta
        title="How Solar Works in Virginia | Jeremy with ION"
        description="A plain-language walk-through of residential solar in Virginia: the Solar 1.0–4.0 evolution, net metering, and how a Power Purchase Agreement (PPA) sets a predictable rate."
      />
      <section className="pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow">How Solar Works</div>
          <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#0F382C] max-w-4xl">
            You buy the <span className="italic">power</span> — not the equipment.
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">
            The short version of a Virginia Power Purchase Agreement, plus the net-metering rules that determine the economics.
          </p>
        </div>
      </section>
      <SolarEvolution />
      <NetMeteringDiagram />
      <PPAComparison />
    </main>
  );
}
